export default "__VITE_ASSET__C1PiHkL6__"